/**
 * PhoneShell — constrains the app to a mobile-native feeling frame on all devices.
 * On desktop it appears as a centered "device" with a soft glow.
 * On mobile it fills the viewport.
 *
 * When children are rendered on an /admin/* route, the phone frame is bypassed
 * so the admin panel can use the full viewport.
 */
import { useLocation } from "react-router-dom";

const PhoneShell = ({ children }) => {
    const loc = useLocation();
    const isAdmin = loc.pathname === "/admin" || loc.pathname.startsWith("/admin/");
    if (isAdmin) {
        return <div data-testid="admin-shell">{children}</div>;
    }
    return (
        <div className="phone-frame" data-testid="phone-shell">
            {children}
        </div>
    );
};

export default PhoneShell;
